<template lang="html">
  <section
    class="draggable-item"
    :id="id"
    :draggable="draggable"
    @dragstart.stop="onDragStart($event)"
    @dragend.stop="onDragEnd($event)"
    @drop.stop="onDrop($event)"
    @dragover.prevent.stop
    @dragenter.stop="onDragEnter($event)"
    @dragleave.stop="onDragLeave($event)"
  >
    <slot></slot>
  </section>
</template>

<script lang="js">
  export default  {
    name: "draggable-item",
    components: {},
    props: {
      id: {},
      draggable: {
        type: Boolean,
        default: true
      },
      info: {
        type: Object
      }
    },
    mounted () {},
    data () {
      return {}
    },
    methods: {
      onDragStart(ev) {
        if(this.$slots.default) {
          ev.dataTransfer.effectAllowed = this.dropEffect;
          ev.data = {info: this.info};
          this.$el.classList.add("m-drag_start");
          for(const [, slot] of Object.entries(this.$slots.default)) {
            if(slot.tag && slot.componentInstance) {
              slot.elm.classList.add("m-drag_start");
              ev.componentInstance = slot.componentInstance;
            }
          }
          this.emitEvent("on-draggable-drag-start", ev);
        }
      },
      onDragEnd(ev) {
        ev.data = {info: this.info};
        this.emitEvent("on-draggable-drag-end", ev);
        this.$el.classList.remove("m-drag_start");
        if(this.$slots.default) {
          for(const [, slot] of Object.entries(this.$slots.default)) {
            if(slot.tag) {
              slot.elm.classList.remove("m-drag_start");
            }
          }
        }
      },
      onDragEnter(ev) {
        ev.data = {info: this.info};
        this.emitEvent("on-draggable-drag-enter", ev);
      },
      onDragLeave(ev) {
        ev.data = {info: this.info};
        this.emitEvent("on-draggable-drag-leave", ev);
      },
      onDrop(ev) {
        ev.data = {info: this.info};
        if(this.$slots.default) {
          for(const [, slot] of Object.entries(this.$slots.default)) {
            if(slot.tag && slot.componentInstance) {
              ev.componentInstance = slot.componentInstance;
            }
          }
        }
        this.emitEvent("on-draggable-drop", ev);
      },
      emitEvent(eventName, evData) {
        if(this.$listeners[eventName] || this._events[eventName]) {
          this.$emit(eventName, evData);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
</style>
